import styled from 'styled-components';
import { googleColor, kakaoColor, whiteColor } from '../../theme/colors';

export const LoginButtonsContainer = styled.div`
  display: flex;
  width: 100%;
  bottom: 100px;
  padding: 0 24px 100px 24px;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
`;

export const KakaoLoginButton = styled.a`
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
  background-color: ${kakaoColor};
  border-radius: 12px;
  padding: 1rem 0;
  margin: 1rem 0;
  z-index: 1;
  span {
    margin-left: 0.5rem;
    font-size: 1rem;
    font-weight: 600;
    text-align: center;
    color: #000000d9;
  }
`;

export const GoogleLoginButton = styled.a`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  background-color: ${googleColor};
  border-radius: 12px;
  padding: 2px 2px;
  margin: 0 0;
  z-index: 1;
  .icon-wrapper {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    left: 0;
    border-radius: 12px;
    background-color: ${whiteColor};
    padding: 1rem;
  }
  span {
    flex: 1;
    margin-right: 2rem;
    font-size: 1rem;
    font-weight: 600;
    text-align: center;
    color: white;
  }
`;
